import { render, staticRenderFns } from "./campuselEctronicfence.vue?vue&type=template&id=1c43dd3d&scoped=true"
import script from "./campuselEctronicfence.vue?vue&type=script&lang=js"
export * from "./campuselEctronicfence.vue?vue&type=script&lang=js"
import style0 from "./campuselEctronicfence.vue?vue&type=style&index=0&id=1c43dd3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43dd3d",
  null
  
)

export default component.exports